module.exports = {"maximeter_analysis":"Análisis de maxímetro","date_range":"Rango de fechas","all_devices":"Todos los dispositivos","graph":"Gráfico","table":"Tabla","max_historical":"Histórico maxímetro"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/es/Maximeter.json
// module id = 606
// module chunks = 1